document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-content-page-toggle]").forEach(
    function (btn) {
      var channelId = btn.getAttribute("data-channel-id");
      var channel = channelId
        ? document.getElementById(channelId)
        : document.getElementById("instantchannel");
      var labelShow = btn.getAttribute("data-label-show") || btn.textContent;
      var labelHide = btn.getAttribute("data-label-hide") || "Read Less";

      if (channel) {
        channel.hidden = true;
      }

      btn.addEventListener("click", function (event) {
        event.preventDefault();

        if (channel) {
          channel.hidden = !channel.hidden;
        }

        var sibling = btn.nextElementSibling;
        if (sibling && sibling.classList.contains("list")) {
          sibling.hidden = !sibling.hidden;
        }

        var showingCollapsedLabel = btn.textContent.trim() === labelShow.trim();
        btn.textContent = showingCollapsedLabel ? labelHide : labelShow;
      });
    },
  );
});
